export const TRANSLATION_SEGMENT_THRESHOLD = 10;

export interface IBlockedLink {
  url: string;
  matchedDomain: string;
  riskLevel: string;
}

export interface ISegmentAnalyzerLinkCheck {
  hasBlockedLinks: boolean;
  blockedLinks: IBlockedLink[];
  allLinks: string[];
  recommendation: string;
}

export interface ISegmentAnalyzerQuickFixReplacement {
  position: number;
  original: string;
  replacement: string;
  type: string;
  unicodePoint: string;
}

export interface ISegmentAnalyzerQuickFix {
  replacements: ISegmentAnalyzerQuickFixReplacement[];
  fixedMessage: string;
  beforeEncoding: string;
  afterEncoding: string;
  beforeSegments: number;
  afterSegments: number;
  fixedCharsList?: string[];
  encodingChange?: string;
}

export interface ISegmentAnalyzerWarning {
  type: string;
  message: string;
}

export interface ISegmentAnalyzerLanguageData {
  language: string;
  translatedMessage: string;
  encoding: string;
  characterCount: number;
  segmentCount: number;
  maxCharsPerSegment: number;
  singleSegmentLimit: number;
  multiSegmentCharLimit: number;
  remainingChars: number;
  riskLevel: string;
  segmentIncrease: number;
  encodingChanged: boolean;
  accentOnlyCause: boolean;
  translationRisk: string | null;
  warnings: ISegmentAnalyzerWarning[];
  linkCheck: ISegmentAnalyzerLinkCheck;
  simplifyForDelivery: {
    available: boolean;
    partial?: boolean;
    simplifiedMessage: string;
    originalEncoding: string;
    simplifiedEncoding: string;
    originalSegments: number;
    simplifiedSegments: number;
    segmentSaved: number;
    charsRemoved: number;
    charsToNextSegmentReduction: number;
    targetCharLimit: number;
    reason: string;
    rewritePrompt: string;
    accentsStrippedCount?: number;
    aiOptimized: {
      status: string;
      message: string;
      encoding: string;
      characterCount: number;
      segmentCount: number;
      riskLevel: string;
      targetSegments: number;
      targetChars: number;
      withinTarget: boolean;
    };
  };
}

export interface ISegmentAnalyzerSourceData {
  encoding: string;
  segmentCount: number;
  message?: string;
  characterCount?: number;
  linkCheck?: ISegmentAnalyzerLinkCheck;
  quickFix?: ISegmentAnalyzerQuickFix;
  hasBlockedLinks?: boolean;
}

export interface ISegmentAnalyzerSummary {
  overallRisk?: string;
  hasTranslationRisks?: boolean;
  hasBlockedLinks?: boolean;
  totalLanguages?: number;
  languagesWithRisk?: number;
  languagesWithSimplifyOption?: number;
  isMMS?: boolean;
}

export interface ISegmentAnalyzerData {
  source: ISegmentAnalyzerSourceData;
  languages?: ISegmentAnalyzerLanguageData[];
  summary?: ISegmentAnalyzerSummary;
  canFixEncoding?: boolean;
}

export interface ISegmentAnalyzerRiskAcceptPayload {
  riskType: string;
  message: string;
  blockedLinks?: string[];
  language?: string;
  orgId: number;
  simplifiedMessage?: string;
  strippedAccentsCount?: number;
  originalSegments?: number;
  newSegments?: number;
  fixedCharsList?: string[];
  encodingChange?: string;
}
